import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
var BreadcrumbsComponent = /** @class */ (function () {
    function BreadcrumbsComponent(store) {
        this.store = store;
        this.staticCrumbs = [];
        this.crumbs = [];
        this.onlyStatic = false;
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    Object.defineProperty(BreadcrumbsComponent.prototype, "prefixUrl", {
        get: function () {
            if (!this.prefix)
                return '/';
            return '/' + (this.prefix + '/').replace(/\//g, '') + '/';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BreadcrumbsComponent.prototype, "hasCrumbs", {
        get: function () {
            return (this.crumbs && (this.crumbs.length > 1))
                || (this.staticCrumbs && (this.staticCrumbs.length > 1));
        },
        enumerable: true,
        configurable: true
    });
    BreadcrumbsComponent.prototype.crumbLink = function (targetIndex) {
        return this.crumbs.reduce(function (prev, curr, idx, arr) {
            if (idx <= targetIndex)
                return prev + curr.slug + '/';
            return prev;
        }, this.prefixUrl);
    };
    return BreadcrumbsComponent;
}());
export { BreadcrumbsComponent };
